import {
  IntegrationChannelType,
  ScheduleViewFragment,
} from 'generated/graphql';

export const getSavedEmailsFromReportSchedule = (
  reportSchedule?: ScheduleViewFragment,
) => {
  const savedEmails =
    reportSchedule?.integrations
      ?.filter(
        (integration) =>
          integration.channel.type === IntegrationChannelType.Email,
      )
      ?.map((integration) => integration.data.emails?.toEmails ?? [])
      ?.flat() ?? [];

  return savedEmails;
};
